/**
 * @generated SignedSource<<09e8b4970c5327bb1ba05b032cfae7d3>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type SentiLinkSsnVerificationError =
  | 'PERMISSION_DENIED'
  | 'RETRYABLE_ERROR'
  | 'UNEXPECTED_ERROR'
  | '%future added value';
export type VerifySSNPageMutation$variables = {
  creditApplicationId: string;
};
export type VerifySSNPageMutation$data = {
  readonly requestSsnVerification: {
    readonly data: {
      readonly ssnVerified: boolean;
    } | null;
    readonly errors: ReadonlyArray<SentiLinkSsnVerificationError>;
  };
};
export type VerifySSNPageMutation = {
  response: VerifySSNPageMutation$data;
  variables: VerifySSNPageMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'creditApplicationId',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                kind: 'Variable',
                name: 'creditApplicationId',
                variableName: 'creditApplicationId',
              },
            ],
            kind: 'ObjectValue',
            name: 'q',
          },
        ],
        concreteType: 'RequestSsnVerificationResponseValidation',
        kind: 'LinkedField',
        name: 'requestSsnVerification',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'RequestSsnVerificationResponse',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'ssnVerified',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errors',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'VerifySSNPageMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'VerifySSNPageMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '81571b99ee59717653531844deca3780',
      id: null,
      metadata: {},
      name: 'VerifySSNPageMutation',
      operationKind: 'mutation',
      text: 'mutation VerifySSNPageMutation(\n  $creditApplicationId: String!\n) {\n  requestSsnVerification(q: {creditApplicationId: $creditApplicationId}) {\n    data {\n      ssnVerified\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'c0ab001bd723d10d3dac8eeeda20d187';

export default node;
